import React, { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { SelectField, TextField } from "components/AddVaccineForm/components";
import { selectableFinancialClasses } from "utils/patientFormOptions";

import s from "../PatientProfileForm.module.css";

export function PatientProfileClassificationGpSection({ isCreate, doctors }) {
  const { setValue } = useFormContext();

  const onFinancialClassChange = useCallback(
    (value) => {
      setValue("financialClass", value);
      setValue("gms", value === "02" || value === "04");
    },
    [setValue]
  );

  const sectionClass = isCreate ? s.sectionCreate : s.sectionEdit;
  const headerClass = isCreate ? s.sectionHeader : s.sectionHeaderEdit;

  return (
    <div className={sectionClass}>
      <h3 className={headerClass}>Social Welfare</h3>
      <div className={s.formGrid3Gp}>
        <SelectField
          name="financialClass"
          label="Patient Classification"
          options={selectableFinancialClasses}
          placeholder="Select"
          onChange={onFinancialClassChange}
        />
        <TextField
          name="medicalCardNumber"
          label="Medical Card Number"
          placeholder="Enter medical card number"
        />
        <SelectField
          name="doctorDetailsId"
          label="Main Doctor"
          options={doctors.map((doc) => ({
            label: doc.label,
            value: String(doc.value),
          }))}
          placeholder="Select"
          onChange={(value) => {
            setValue("doctorDetailsId", value);
          }}
        />
      </div>
    </div>
  );
}
